<template>
  <body>
    <ModalAutores :autores="autores" v-show="modalAutores"
      @cerrar="cerrarModal"
      @recargar="recargarAutores"
      @AddAutor="otroAutor"/>
    <aside class="Blk-1">
      <img class="imgPort" :src="libroVista.portada">
    </aside>
    <aside class="Blk-2">
      <article class="Form">
        <div class="Blk-Campo">
          <p id="titReg">Libros registrados</p>
          <select name="libros" id="" class="campo"
            :disabled = 'habBotAndCamp.hab'
            v-model="libroSel" @change.prevent="mostrarDatosLibro(libroSel._id)">
            <option v-for="libro in listaLibros"
              :key="libro._id"
              :value="libro">
              {{libro.titulo}}
            </option>
          </select>
        </div>
        <form @change="cambioFormLib">
          <div class="Blk-Campo">
            <p>Título*</p>
            <textarea name="titulo" class="campo" ref="nombreLibro" rows="2"
              :disabled = '!habBotAndCamp.hab'
              v-model.trim="libroVista.titulo"
              spellcheck="false"
              autofocus>
            </textarea>
          </div>
          <div class="Blk-Campo">
            <p>Autor(es)</p>
            <div class="campo" @change="cambioAutores" >{{autoresVista}}</div>
            <div class="botonesAut">
              <button class="botAut" @click.prevent="addAutor" :disabled = '!habBotAndCamp.hab'>+</button>
              <button class="botAut" @click.prevent="delAutor" :disabled = '!habBotAndCamp.hab'> - </button>
            </div>
          </div>
          <div class="Blk-Campo">
            <p>Editorial</p>
            <input type="text" name="editorial" class="campo"
              v-model.trim="libroVista.editorial"
              :disabled = '!habBotAndCamp.hab'
            >
          </div>
          <div class="Blk-Campo">
            <p>Índice</p>
            <textarea name="indice" id="indice"  class="campo" rows="5"
              :disabled = '!habBotAndCamp.hab'
              spellcheck="false"
              v-model.trim="libroVista.indice">
            </textarea>
            <div class="formIndTel">
              <button @click="formatoIndice" :disabled = '!habBotAndCamp.hab'>
                Formato índice
              </button>
            </div>
          </div>
          <div class="Blk-Campo">
            <p>Palabras clave</p>
            <textarea name="palabrasClave" class="campo" rows="2" id=""
              :disabled = '!habBotAndCamp.hab'
              v-model.trim="libroVista.palsClave">
            </textarea>
          </div>
          <div class="Blk-Campo">
            <p>Ciudad</p>
            <input type="text" name="ciudad" class="campo"
              v-model.trim="libroVista.ciudad"
              :disabled = '!habBotAndCamp.hab'>
            <p>País</p>
            <input type="text" name="pais" class="campo"
              v-model.trim="libroVista.pais"
              :disabled = '!habBotAndCamp.hab'>
            </div>
          <div class="Blk-Campo">
            <p>Año</p>
            <input type="text" name="ciudad" class="campo"
              v-model.trim="libroVista.anyo"
              :disabled = '!habBotAndCamp.hab'>
            <p>ISBN</p>
            <input type="text" name="pais" class="campo"
              v-model.trim="libroVista.ISBN"
              :disabled = '!habBotAndCamp.hab'>
          </div>
          <div class="Blk-Campo">
            <p>Idioma</p>
            <input type="text" name="idioma" class="campo" list="idiomas" autocomplete="off"
              v-model.trim="libroVista.idioma"
              :disabled = '!habBotAndCamp.hab'>
            <datalist id="idiomas">
              <option value="Español">Español</option>
              <option value="Francés">Francés</option>
              <option value="Italiano">Italiano</option>
              <option value="Inglés">Inglés</option>
              <option value="Japonés">Japonés</option>
              <option value="Portugués">Portugués</option>
            </datalist>
            <p>Tamaño</p>
            <input type="text" name="pais" class="campo"
              v-model.trim="libroVista.size"
              :disabled = '!habBotAndCamp.hab'>
          </div>
          <div class="Blk-Campo">
            <p>Edición</p>
            <input type="text" name="ciudad" class="campo"
              v-model.trim="libroVista.edicion"
              :disabled = '!habBotAndCamp.hab'>
            <p>Páginas</p>
            <input type="text" name="pais" class="campo"
              v-model.trim="libroVista.paginas"
              :disabled = '!habBotAndCamp.hab'>
          </div>
          <div class="Blk-Campo">
            <div class="check">
              <p>Formato papel</p>
              <input type="checkbox" name="fPapel"
                v-model.trim="libroVista.papel"
                :disabled = '!habBotAndCamp.hab'>
            </div>
            <div class="check">
              <p>Formato electrónico</p>
              <input type="checkbox" name="fElec"
                v-model.trim="libroVista.digital"
                :disabled = '!habBotAndCamp.hab'>
            </div>
            <div class="check">
              <p>Información reservada</p>
              <input type="checkbox" name="privado"
                class="checkMark"
                :disabled = '!habBotAndCamp.hab'
                v-model.trim="libroVista.reservado">
            </div>
          </div>
          <div class="BtnImg">
            <input type="file" name="file-1" id="file-1"
            class="inputfile"
            :disabled = '!habBotAndCamp.hab'
            @change="cargarPortada"/>
            <label for="file-1" ><span class="icon-icoSubirImg"></span></label>
            <p id="eti">Cargar portada</p>
          </div>
          <img class="imgPort2" :src="libroVista.portada">
        </form>
      </article>
      <aside class="Btns">
        <BotonesCRUD
        :desacMas="!habBotAndCamp.actMas"
        :desacEdit="!habBotAndCamp.actEdi"
        :desacMenos="!habBotAndCamp.actMen"
        :desacSave="!habBotAndCamp.actSav"
        @nuevo="nuevoLibro"
        @editar="editarLibro"
        @del="borrarLibro"
        @save="saveLibro"
        />
        <div class="formInd">
          <button @click="formatoIndice" :disabled = '!habBotAndCamp.hab'>Formato índice</button>
        </div>
      </aside>
    </aside>
  </body>
</template>

<script>
import { mapState } from 'vuex' // en Computed está ...mapState(['usuarioEnSesion'])
import BotonesCRUD from '../components/BotonesCRUD.vue'
import ModalAutores from '../components/ModalAutores.vue'
import axios from 'axios'
export default {
  name: 'FormLibros',
  components: { BotonesCRUD, ModalAutores },
  created () {
    this.URLbase = process.env.VUE_APP_ROOT_API
    this.token = this.usuarioEnSesion.tokenUser
    this.getListaLibros() // Trae lista de nombres de libros sin otros datos
    this.getAutores() // Trae la lista de autores
    this.activaModo('INI')
  },
  data () {
    return {
      modalAutores: false,
      libroSel: [],
      libroSelBkUp: [],
      listaLibros: [],
      libroVista: {},
      libroVistaBkUp: {},
      autores: [],
      autoresLibro: [],
      autoresLibroBkUp: [],
      habBotAndCamp: {
        actMas: false,
        actEdi: false,
        actMen: false,
        actSav: false,
        hab: false
      },
      IsModoSalirMas: false,
      IsModoSalirEdi: false,
      URLbase: '',
      token: ''
    }
  },
  methods: {
    async getListaLibros () {
      try {
        const url = `${this.URLbase}/libros/listaLibros`
        const res = await fetch(url)
        this.listaLibros = await res.json()
      } catch (error) {
        alert(error)
      }
    },
    mostrarDatosLibro (IdLibro) {
      this.getDatosLibro(IdLibro)
      this.activaModo('LibS')
    },
    async getDatosLibro (IdSelecc) {
      try {
        const url = `${this.URLbase}/libros/getLibroData`
        const libroId = { _id: IdSelecc }
        axios.post(url, libroId)
          .then(result => {
            const datosLibro = result.data
            this.libroVista = datosLibro
            this.autoresLibro = datosLibro.autores
          })
          .catch(error => console.log(error))
      } catch (error) {
        alert(error)
      }
    },
    editarLibro () {
      this.IsModoSalirEdi = !this.IsModoSalirEdi
      // Si es modo edición, hace copia de los datos actuales por si se cancela
      if (this.IsModoSalirEdi) {
        this.libroVistaBkUp = JSON.parse(JSON.stringify(this.libroVista))
        this.autoresLibroBkUp = JSON.parse(JSON.stringify(this.autoresLibro))
        this.libroSelBkUp = this.libroSel
        this.activaModo('LibEDI')
      } else {
        // Si se cancela, resatura los valores previos
        this.libroVista = JSON.parse(JSON.stringify(this.libroVistaBkUp))
        this.autoresLibro = JSON.parse(JSON.stringify(this.autoresLibroBkUp))
        this.libroSel = this.libroSelBkUp
        this.activaModo('LibS')
      }
    },
    cambioFormLib () {
      if (this.IsModoSalirMas && this.minDataLib) {
        this.activaModo('LibMASs')
      }
      if (this.IsModoSalirEdi && this.minDataLib) {
        this.activaModo('LibEDIs')
      }
    },
    async borrarLibro () {
      const response = await this.$root.alertJoa(
        'Estás a punto de borrar el registro de este libro. Esta acción no puede revertirse ¿Quieres continuar?',
        'W', 'C'
      )
      if (response === 'borrar') {
        try {
          const url = `${this.URLbase}/libros/borrarLibro`
          const libroId = { _id: this.libroVista._id }
          axios.post(url, libroId, {
            headers: {
              authorization: this.token
            }
          })
            .then(result => {
              switch (result.status) {
                case 200:
                  this.blanquearLibroVista()
                  this.alertJoa('¡Registro borrado con éxito!', 'S')
                  this.getListaLibros()
                  break
                case 500:
                  this.alertJoa('Error al borrar registro, intenta otra vez', 'E')
                  break
                default:
                  this.alertJoa('Algo salió mal, intenta otra vez', 'E')
              }
            })
            .catch(error => {
              console.log(error)
              this.alertJoa('Error al borrar registro, intenta otra vez', 'E')
            })
        } catch (error) {
          alert(error)
        }
      }
    },

    async saveLibro () {
      this.libroVista.autores = this.autoresLibro
      try {
        const url = `${this.URLbase}/libros/save`
        const libro = this.libroVista
        axios.post(url, libro, {
          headers: {
            authorization: this.token
          }
        })
          .then(result => {
            switch (result.data) {
              case 'error':
                this.alertJoa('Error al guardar, intenta otra vez', 'E')
                break
              case 'success':
                this.alertJoa('Datos guardados con éxito!', 'S')
                break
            }
            this.getListaLibros()
          })
      } catch (error) {
        alert(error)
      }
      // this.getListaLibros()
      this.IsModoSalirMas = false
      this.IsModoSalirEdi = false
      this.blanquearLibroVista()
      this.activaModo('INI')
    },
    async getAutores () {
      try {
        const url = `${this.URLbase}/autores/listAutores`
        const res = await fetch(url)
        this.autores = await res.json()
      } catch (error) {
        alert(error)
      }
    },
    // Si hay nombre del libro abre el modal para añadir autores
    addAutor () {
      if (this.libroVista.titulo) { this.modalAutores = true }
    },
    recargarAutores () {
      this.getAutores()
    },
    // Elimina el último autor asociado al libro
    delAutor () {
      this.autoresLibro.pop()
    },
    // Añade los autores en orden de un libro
    otroAutor (autorRecibido) {
      if (!this.autoresLibro.includes(autorRecibido)) {
        this.autoresLibro.push(autorRecibido)
      }
    },
    cerrarModal () {
      this.modalAutores = false
    },
    nuevoLibro () {
      this.IsModoSalirMas = !this.IsModoSalirMas
      if (this.IsModoSalirMas) {
        this.libroVistaBkUp = JSON.parse(JSON.stringify(this.libroVista))
        this.autoresLibroBkUp = JSON.parse(JSON.stringify(this.autoresLibro))
        this.libroSelBkUp = JSON.parse(JSON.stringify(this.libroSel))
        this.blanquearLibroVista()
        this.activaModo('LibMAS')
        // this.setFocus()
      } else {
        this.libroSel = this.libroSelBkUp
        if (this.libroSel.titulo) {
          this.libroVista = JSON.parse(JSON.stringify(this.libroVistaBkUp))
          this.autoresLibro = JSON.parse(JSON.stringify(this.autoresLibroBkUp))
          this.activaModo('LibS')
        } else {
          this.blanquearLibroVista()
          this.activaModo('INI')
        }
      }
    },
    blanquearLibroVista () {
      this.libroVista = {}
      this.autoresLibro = []
      this.libroSel = []
    },
    cargarPortada (event) {
      // Asignamos la imagen a nuestra data
      const portada = event.target.files[0]
      // Si imagen > 500kB alertamos y salimos
      const tamaño = portada.size
      if (tamaño > 500000) {
        this.alertJoa('El tamaño del archivo es: ' +
        Math.round(tamaño / 1000) +
        'kb. Por favor, selecciona un archivo de un tamaño menor a 500 kb', 'W')
      } else {
        // Cargamos la previsualización
        const reader = new FileReader()
        reader.readAsDataURL(portada)
        reader.onload = e => { this.libroVista.portada = e.target.result }
      }
    },
    activaModo (modo) {
      switch (modo) {
        case 'INI':
          this.confModo = [1, 0, 0, 0, 0]
          break
        case 'LibS':
          this.confModo = [1, 1, 1, 0, 0]
          break
        case 'LibMAS':
          this.confModo = [1, 0, 0, 0, 1]
          break
        case 'LibMASs':
          this.confModo = [1, 0, 0, 1, 1]
          break
        case 'LibEDI':
          this.confModo = [0, 1, 0, 0, 1]
          break
        case 'LibEDIs':
          this.confModo = [0, 1, 0, 1, 1]
          break
      }
      let i = 0
      for (const key in this.habBotAndCamp) {
        this.confModo[i] === 0
          ? this.habBotAndCamp[key] = false
          : this.habBotAndCamp[key] = true
        i++
      }
    },
    formatoIndice () {
      if (!this.libroVista.indice) { return }
      const numEle = this.libroVista.indice.length
      let i = 0
      let char = ''
      let charPlus = ''
      let numPoint = 0
      let espB = false
      this.indice = ''
      while (i < numEle) {
        char = this.libroVista.indice[i]
        charPlus = this.libroVista.indice[i + 1]
        if (char !== ' ' && char !== '.') {
          this.indice = this.indice.concat(char)
          espB = false
          numPoint = 0
        } else {
          if (char === ' ') {
            if (!espB) {
              if (charPlus !== '.') {
                this.indice = this.indice.concat(char)
                espB = true
              }
            }
          } else {
            if (numPoint < 4) {
              numPoint++
              this.indice = this.indice.concat(char)
            } else {
              if ((charPlus !== '.') && (charPlus !== ' ')) {
                this.indice = this.indice.concat(' ')
              }
            }
          }
        }
        i++
      }
      this.libroVista.indice = this.indice
    }
  },
  computed: {
    autoresVista () {
      // const A = this.autoresLibro.map((e) => this.autores.find((autor) => autor._id === e))
      return this.autoresLibro.map((ele) => `${ele.nombre} ${ele.apellidos}`).join(', ')
    },
    // autoresId () {
    //   const autoresId = []
    //   this.autoresLibro.map((ele) => autoresId.push(ele._id))
    //   return autoresId
    // },
    minDataLib () {
      return (this.libroVista.titulo && this.autoresLibro.length > 0)
    },
    ...mapState(['usuarioEnSesion'])
  },
  watch: {
    autoresVista () {
      if ((this.IsModoSalirEdi || this.IsModoSalirMas) && this.autoresLibro.length > 0) {
        this.cambioFormLib()
      }
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
body {
  width: 100vw;
  height: 82vh;
  display: flex;
  flex-direction: row;
  overflow: hidden;
}
aside.Blk-1 {
  width: 20%;
  background-color: var(--az-cl-tr08);
  border: solid 0.5px var(--az-cl-tr08);
}
.imgPort{
  margin-top: 75px;
  width:80%;
  justify-self: center;
  box-shadow: rgb(53, 52, 52) 5px 5px 7px;
}
.imgPort2{
  display:none;
}
aside.Blk-2 {
  width: 80%;
  display: grid;
  grid-template-columns: 80% 20%;
  background-color: var(--gr-fo-for);
  overflow-y: auto;
  overflow-x: hidden;
  padding-bottom: 1.5%;
}
article.Form {
  padding-top: 20px;
}
.Btns {
  /* display: grid; */
  padding-left: 20px;
  padding-top: 20px;
  /* position: fixed; */
  /* width:15%; */
  /* top:150px; */
  /* right:10px; */
  /* border: solid 1px orange; */
}
.formInd{
  margin-top: 55px;
}
.formIndTel{
  display:none;
}
.Blk-Campo{
  width: 100%;
  /* flex:20; */
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 4px;
}
.Blk-Campo p {
  color: black;
  font-weight: normal;
  font-size: 13px;
  text-align: left;
  padding-left: 18px;
  max-width: 90px;
  min-width: 90px;
  margin-bottom: 2px;
  line-height: 98%;
}
.campo{
  height: auto;
  min-height: 26px;
  width: auto;
  min-width: 70px;
  /* margin-left: 10px; */
  padding-left: 8px;
  background-color: var(--gr-fo-cam);
  border: var(--bo-cam);
  border-radius: 3px;
  font-size: 15px;
  color: var(--tx-cam);
  /* color: rgb(10, 90, 140); */
  flex: 2;
  text-align: left;
}
.campo:focus{
  outline-color: var(--az-ico);
}
.check{
  display: flex;
  margin-top: 2%;
}
.check p {
  color: black;
  font-weight: normal;
  font-size: 13px;
  text-align: left;
  padding-left: 18px;
  padding-right: 4px;
  max-width: 150px;
  min-width: 90px;
  margin-bottom: 2px;
  line-height: 98%;
}
.botAut{
  height: auto;
  min-height: 26px;
  width: 26px;
  font-size: 18px;
}
#titReg{
  font-weight: bold;
}
.BtnImg{
  display:flex;
  align-items: center;
}
.BtnImg p{
  color:black;
  font-size: 13px;
  padding-top: 4px;
}
.inputfile {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: relative;
  /* z-index: -1; *****/
  visibility:hidden;
}
/*Esta clase da el formato al boton y la etiqueta */
.inputfile + label {
  /* width: 63.5%;  */
  cursor: pointer;
  padding: 5px;
  text-align: left;
  margin-bottom: 6px;
  margin-top: 6px;
  color: black;
  font-size: 16px;
}
.inputfile + label:hover {
  transform: scale(1.08);
  /* background-color: rgb(192, 205, 206); */
  /* .inputfile:focus + label, .inputfile.has-focus + label,*/
}
.inputfile:disabled + label {
  color: #8fa3ad;
}
.icon-icoSubirImg {
  color: rgb(30, 85, 130);
  font-size: 1.45em;
  padding-left: 9px;
  padding-right: 9px;
}
.checkMark{
  color: rgb(30, 85, 130);
}
input[type=checkbox] {
  transform: scale(1.2);
}
@media screen and (max-width: 576px){
  body {
    width: 100vw;
    /* height: auto; */
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }
  .Blk-1{
    display: none;
  }
  aside.Blk-2 {
    width: 100%;
    display: flex;
    flex-direction: column-reverse;
    align-items: stretch;
  }
  .Form {
    padding-top: 10px;
    overflow: scroll;
  }
  .Blk-Campo {
    flex-direction: column;
    /* align-items:flex-start; */
    align-items:stretch;
  }
  .Blk-Campo p{
    max-width: 190px;
  }
  .campo{
    /* width: 100% no funciona, el ancho se controla con align-items: strech en .Blk-Campo*/
    margin: 0 2% 0 2%;
  }
  .check{
    width: 43%;
    justify-content: space-between;
    margin-top: 6px;
    /* border: solid 1px orange; */
  }
  .Btns {
    padding: 0 2.5% 2% 2.5%;
    /* background-color:  rgba(209, 208, 183, 0.911); */
    /* border: solid 1px orange; */
  }
  .formInd{
    display: none;
  }
  .formIndTel{
    display: block;
    align-self: end;
    margin-right: 2%;
  }
  textarea {
    resize: none;
  }
  .botonesAut{
    align-self: flex-end;
    margin-right: 2.5%;
  }
  .imgPort2{
    display:inline-flex;
    width: 65%;
    margin-top: 5px;
    margin-bottom:15px;
    justify-self: center;
    box-shadow: rgb(53, 52, 52) 5px 5px 7px;
  }

}
</style>
